function setPlaylistNameIntoField() {
    document.querySelector('.js-playlist-name-field').value = playlistName;
}

$('.js-edit-playlist-data-btn').on('click', setPlaylistNameIntoField);
